var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.visible,"fullscreen":"","append-to-body":""},on:{"close":function($event){return _vm.$emit('close')}}},[_c('img',{attrs:{"width":"100%","src":_vm.url,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }